<template>
  <div class="x-ellipsis">
    <el-tooltip effect="dark" :content="label" placement="top-start">
      <span>{{ label }}</span>
    </el-tooltip>
  </div>
</template>
<script>

export default {
  name: 'XEllipsis',
  props: {
    label: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="scss">
.x-ellipsis {
  span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
